import type { GoldConfig } from '@iheartjane/data-access';
import type { AppMode } from '@iheartjane/types';
import { Storage, statePostalCode } from '@iheartjane/utils';

export interface ShouldShowGoldArgs {
  appMode: AppMode;
  /** NB: the null state helps cover for loading states. You should still make an attempt to fetch the GoldConfig for this check. */
  goldConfig: GoldConfig | null;
  state?: string | null;
  storeId?: string | number;
}

export const shouldShowGold = ({
  appMode,
  goldConfig,
  state,
  storeId,
}: ShouldShowGoldArgs): boolean => {
  if (!goldConfig) return true;

  const stateCode =
    statePostalCode(state) || Storage.get<string>('state') || '';

  if (appMode === 'default' && !!stateCode) {
    return goldConfig.states.includes(stateCode);
  }

  // For all other app modes, check the store ID
  if (storeId) {
    return goldConfig.store_ids.includes(Number(storeId));
  }

  return false;
};
